








import Vue from "vue";
import * as firebase from "firebase/app";
import "firebase/auth";
import "@/types/number";

export default Vue.extend({
  async beforeCreate(): Promise<void> {
    firebase.auth().onAuthStateChanged((user: firebase.User | null) => {
      if (user) {
        localStorage.setItem("userId", user.uid);
        this.$router.push({ name: "Home" });
       } else {
        localStorage.clear();
        this.$store.dispatch("setExpenses", []);
        this.$router.push({ name: "GetStarted" });
      }
    });
  },
});
